import {
  ArrowForward,
  Close,
  Facebook,
  Google,
  Instagram,
  LinkedIn,
  OpenInNew,
  Pinterest,
  Twitter,
  X,
  YouTube,
} from '@mui/icons-material';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useDialogState } from '~/hooks/useDialogState';

type SocialLinkButtonProps = {
  url: string;
};

export const SocialLinkButton = ({ url }: SocialLinkButtonProps) => {
  const { t } = useTranslation();

  const confirmDialog = useDialogState();

  const mapToSocialIcon = () => {
    const name = new URL(url).hostname;

    if (name.includes('snapchat.')) {
      return <OpenInNew sx={{ color: '#FFFC00' }} />;
    } else if (name.includes('pinterest.')) {
      return <Pinterest sx={{ color: '#BD081C' }} />;
    } else if (name.includes('facebook.')) {
      return <Facebook sx={{ color: '#3B5998' }} />;
    } else if (name.includes('tumblr.')) {
      return <OpenInNew sx={{ color: '#35465c' }} />;
    } else if (name.includes('vk.')) {
      return <OpenInNew sx={{ color: '#45668e' }} />;
    } else if (name.includes('vimeo.')) {
      return <OpenInNew sx={{ color: '#1ab7ea' }} />;
    } else if (name.includes('youtube.')) {
      return <YouTube sx={{ color: '#FF0000' }} />;
    } else if (name.includes('instagram.')) {
      return <Instagram sx={{ color: '#262626' }} />;
    } else if (name.includes('twitter.')) {
      return <X sx={{ color: '#1DA1F2' }} />;
    } else if (name.includes('x.')) {
      return <Twitter sx={{ color: '#1DA1F2' }} />;
    } else if (name.includes('google.')) {
      return <Google sx={{ color: '#DB4437' }} />;
    } else if (name.includes('linkedin.')) {
      return <LinkedIn sx={{ color: '#0077B5' }} />;
    } else {
      return <OpenInNew sx={{ color: '#336699' }} />;
    }
  };

  const proceedToLink = () => {
    window.open(url, '_target');
    confirmDialog.close();
  };

  return (
    <>
      <Tooltip title={url} arrow={true} placement={'bottom-start'}>
        <IconButton
          aria-label="close"
          size="small"
          color="primary"
          onClick={confirmDialog.open}
        >
          {mapToSocialIcon()}
        </IconButton>
      </Tooltip>
      <DraggableDialog
        open={confirmDialog.isOpen}
        onClose={confirmDialog.close}
      >
        <SolaForceDialogTitle>{t('laNotice')}</SolaForceDialogTitle>
        <DialogContent>
          <Box component="p">{t('laWarningLinkOutsideSystem')}</Box>
          <Box>
            {t('laUrl')}: {url}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button startIcon={<ArrowForward />} onClick={proceedToLink}>
            {t('laProceedAndOpen')}
          </Button>
          <Button
            color="error"
            startIcon={<Close />}
            onClick={confirmDialog.close}
          >
            {t('laDoNotProceed')}
          </Button>
        </DialogActions>
      </DraggableDialog>
    </>
  );
};
